import {
    fetchOptionChainExpDates,
    setOptionChainExpDates,
    fetchOptionChain,
    setOptionChain,
    fetchAboveOptionChainItems,
    fetchBelowOptionChainItems,
    setBelowPageUrl,
    setBelowPageOptionChainData,
    setAbovePageUrl,
	setAbovePageOptionChainData,
} from '../reducers/equity/optionChain/optionChain';
import {
  setForceReloadOptionChain,
} from '../reducers/equity/optionChain/optionChainLookUpData'
import {
    get_option_chain_expiry_dates,
    get_option_chain_data,
    get_option_chain_next_page
} from '../../apis/optionChain';
import { setActionError, resetActionError } from '../reducers/actionError';
import { setActionLoaderTrue, setActionLoaderFalse } from '../reducers/actionLoader';
import { call, put, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash-es';
import { setOptionChainLoader } from '../reducers/equity/optionChain/optionChainLoader';

function* handleFetchOptionChainV2ExpiryDate({ payload = {} }) {
	const { Api, token, segment_id,  selectedOptionChainId } = payload;
	try {
		yield put(resetActionError(fetchOptionChainExpDates))
		yield put(setActionLoaderTrue(fetchOptionChainExpDates));
		const response = yield call(
			get_option_chain_expiry_dates,
			Api,
			token,
			segment_id,
		);
		const data = get(response, 'data', []);
		yield put(setOptionChainExpDates({expiryDateOptions: data, selectedOptionChainId}))
	} catch (error) {
		yield put(setActionError({isFetchFailed : true,message: error.message, actionName: fetchOptionChainExpDates}))
	} finally {
		yield put(setActionLoaderFalse(fetchOptionChainExpDates));
	}
}

function* handleFetchOptionChainV2 ({payload = {}}) {
	const {Api,  params, selectedOptionChainId, selectedOptionChainScreenId } = payload;
	try {
       yield put(resetActionError(fetchOptionChain));
	   yield put(setOptionChainLoader({isLoading: true, screenId: selectedOptionChainScreenId}))
	   const response = yield call(get_option_chain_data, Api, params);
	   yield put(setOptionChain({selectedOptionChainId, optionChainData: response}));
	} catch (error) {
		yield put(setActionError({isFetchFailed : true,message: error.message, actionName: fetchOptionChain}))
	} finally {
		yield put(setOptionChainLoader({isLoading: false, screenId: selectedOptionChainScreenId}))
		yield put(setForceReloadOptionChain({ uniqueOptionChainId: selectedOptionChainScreenId, isForceReload: false,}));
	}
}

function* handleFetchOptionChainAboveItems ({payload = {}}) {
	const {Api, url, selectedOptionChainId } = payload;
	try {
		yield put(setActionLoaderTrue(fetchAboveOptionChainItems));
		const response = yield call(
			get_option_chain_next_page,
			Api,
			url,
		);
		const {above_page_url, data} = response;
		yield put(setAbovePageUrl({selectedOptionChainId, above_page_url}));
		yield put(setAbovePageOptionChainData({selectedOptionChainId, optionChainData: data}))
	}  catch(error) {
        console.log('error in fetching the above page of the option chain');
	} finally {
        yield put(setActionLoaderFalse(fetchAboveOptionChainItems));
	}
}

function* handleFetchOptionChainBelowItems ({payload = {}}) {
	const {Api, url, selectedOptionChainId } = payload;
	try {
		yield put(setActionLoaderTrue(fetchBelowOptionChainItems));
		const response = yield call(
			get_option_chain_next_page,
			Api,
			url,
		);
		const {below_page_url, data} = response;
		yield put(setBelowPageUrl({selectedOptionChainId, below_page_url}));
		yield put(setBelowPageOptionChainData({selectedOptionChainId, optionChainData: data}))
	}  catch(error) {
        console.log('error in fetching the below page of the option chain');
	} finally {
        yield put(setActionLoaderFalse(fetchBelowOptionChainItems));
	}
}

export default function* sagaFetchOptionChain() {
	yield takeLatest(fetchOptionChainExpDates, handleFetchOptionChainV2ExpiryDate);
	yield takeLatest(fetchOptionChain, handleFetchOptionChainV2);
	yield takeLatest(fetchAboveOptionChainItems, handleFetchOptionChainAboveItems);
	yield takeLatest(fetchBelowOptionChainItems, handleFetchOptionChainBelowItems);
}

